import React from 'react';

import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.normalText,
    ...common.flexInline,
    ...common.justifyBetween,
    alignItems: 'center',
    lineHeight: 'initial',
    padding: '12px 12px',
  },
  heading: {
    fontSize: 32,
    fontWeight: 500,
  },
}));

export interface SectionTitleProps {
  actions?: React.ReactElement | React.ReactElement[];
}

export const SectionTitle: React.FC<React.PropsWithChildren<SectionTitleProps>> = (props) => {
  const classes = useStyles();

  const { children, actions } = props;

  return (
    <div className={clsx(classes.container)}>
      <div role="heading" className={classes.heading}>
        {children}
      </div>
      <div>{actions}</div>
    </div>
  );
};
